import React, {FC} from 'react'
import {useTranslation} from 'react-i18next'

import {Box, Theme, Typography} from '@mui/material'
import {PGTypography} from '@progynyglobal/pg-ui-library'
import {makeStyles} from 'tss-react/mui'

import BackButton from '@progyny/components/Buttons/BackButton'

const useStyles = makeStyles()((theme: Theme) => ({
  title: {
    marginBottom: theme.spacing(4),
  },
}))

type Props = {
  title: string
  memberId?: string
  subTitle?: string
}

export const SubpageHeader: FC<Props> = ({title, memberId, subTitle}) => {
  const {classes} = useStyles()
  const {t} = useTranslation()
  return (
    <>
      <Box mb={2}>
        <BackButton />
      </Box>
      <Box
        display={'flex'}
        alignItems={{xs: 'flex-start', sm: 'baseline'}}
        flexDirection={{xs: 'column', sm: 'row'}}
        gap={2}
      >
        <Box>
          <Typography
            variant={'h4'}
            className={classes.title}
            sx={{marginBottom: subTitle ? '12px !important' : 4}}
          >
            {title}
          </Typography>
          {subTitle && (
            <PGTypography variant='subtitle'>{subTitle}</PGTypography>
          )}
        </Box>
        {memberId && (
          <Typography
            fontSize={12}
            fontWeight={500}
            color={'#4A0D0D'}
            padding={1}
            sx={{
              backgroundColor: '#E9F5F6',
              borderRadius: 1,
              position: 'relative',
              bottom: 3,
            }}
          >{`${t('profile_header_member_id')}: ${memberId}`}</Typography>
        )}
      </Box>
    </>
  )
}
